import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useItems } from '../contexts/ItemsContext';
import { useUser } from '../contexts/UserContext';
import ProductCard from './ProductCard';
import './ProgramsSection.css';
import useSectionInView from '../useSectionInView';
import '../sectionAnimations.css';

export default function ProgramsSection() {
  const [ref, visible] = useSectionInView();
  const { itemsByGenre, loadItems, loadingByGenre } = useItems();
  const { user, addFavorite, removeFavorite } = useUser();
  const navigate = useNavigate();
  const genre = 'תוכנית';

  useEffect(() => {
    loadItems(genre);
  }, [genre, loadItems]);

  const items = itemsByGenre[genre] || [];
  const loading = loadingByGenre[genre];

  const isItemFavorite = (item) => {
    if (!user?.likes) return false;
    return user.likes.some(like => like.id === item.id);
  };

  const toggleFavorite = async (item) => {
    if (!user) return;
    if (isItemFavorite(item)) {
      await removeFavorite(item.id);
    } else {
      await addFavorite(item);
    }
  };

  const handleAddToCart = (item) => {
    // כאן אפשר להוסיף לוגיקה של הוספה לסל בעתיד
    console.log('Add to cart:', item);
  };

  const handleViewAll = () => {
    navigate('/programs');
  };

  // מוצגים רק 5 ראשונים
  // const displayedItems = items.slice(0, 5);
  const displayedItems = items;

  return (
    <section ref={ref} className={`home-programs-section section-fade-in-up${visible ? ' visible' : ''}`}>
      <div className="home-section-header">
        <div className="home-section-texts">
        <h3 className="home-section-title">נבחרת</h3>
        <h3 className="home-section-title">התוכניות שלנו</h3>
        </div>
        <button className="home-view-all-btn-3" onClick={handleViewAll}>
               ←  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    לכל התוכניות     
        </button>
      </div>
      {loading ? (
        <div className="home-loading">טוען תוכניות...</div>
      ) : (
        <div className="home-products-scroll">
          {displayedItems.length > 0 ? (
            displayedItems.map((item) => (
              <ProductCard
                key={item.id}
                item={item}
                onAddToCart={handleAddToCart}
                onToggleFavorite={toggleFavorite}
                isFavorite={isItemFavorite(item)}
              />
            ))
          ) : (
            <div className="home-empty">אין תוכניות להצגה</div>
          )}
        </div>
      )}
    </section>
  );
}



